<template>
  <select-list v-if="list && list.length" :list="list" class="activity-sessions" v-model="current" :col="col">
    <template #default="{data}">
      <div class="activity-sessions__item">
        <p class="activity-sessions__title">
          <span>{{ formatDate(data.formatDate) }}</span>
        </p>
        <p class="activity-sessions__time">
          {{ data.formatTime }} {{ data.formatDesc }}
        </p>
        <span v-if="!data.available"
              class="activity-sessions__sign">{{ $t('content.activitySessionFull') }}</span>
      </div>
    </template>
  </select-list>
</template>

<script>
import SelectList from './SelectList';

export default {
  name: 'Sessions',
  components: {
    SelectList
  },
  props: {
    value: {
      type: Number
    },
    list: {
      type: Array
    },
    col: {
      type: Number
    }
  },
  data(){
    return {
      current: this.value
    };
  },
  watch: {
    current(val){
      this.$emit('change', val);
    },
    value(val){
      if (val !== this.current){
        this.current = val;
      }
    }
  },
  methods: {
    formatDate(date){
      if (!date){
        return '';
      }
      const {dateRange, weekday, dayDiff} = date;

      return `${dayDiff > 0 ? `${dayDiff} ${this.$t('content.activitySceneFormatDay')}` : weekday}, ${dateRange}`;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.activity-sessions {
  &__item {
    position: relative;
  }

  &__title {
    // padding-right: sizeTrans(45);
    @include font_tips_m();
    // font-weight: $bold;
    @include blue_sky_bold;
    white-space: pre-line;
  }

  &__desc {
    margin-top: sizeTrans($space_15);
    @include font_tips_s();
  }

  &__time {
    margin-top: sizeTrans($space_5);
    @include font_tips_s();
  }

  &__sign {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 sizeTrans($space_5);
    height: sizeTrans(16);
    line-height: sizeTrans(16);
    color: #EBEBEE;
    border: 1px solid #EBEBEE;
    font-size: 10px;
    border-radius: sizeTrans(16);
    box-sizing: border-box;
  }
}
</style>